package com.eladfinish.bible.contest.ads

import com.eladfinish.bible.contest.constants.SharedPrefsConstants
import com.eladfinish.bible.contest.currentMilliseconds
import com.eladfinish.bible.contest.platform.isAndroid
import com.eladfinish.bible.contest.platform.isIos
import com.russhwolf.settings.Settings

/**
 * Single source of truth for "should ads be shown right now?", applied app-wide
 * (main-screen banner, search-dialog native ad, …).
 *
 * Ads are suppressed when the user is inside the rewarded ad-free window
 * (AD_FREE_UNTIL_MILLIS) or has purchased ad removal. Only Android and iOS have an
 * ads SDK; the web app never shows in-app ads.
 */
class ShouldShowAdsUseCase(
    private val settings: Settings,
    private val hasAdsSdk: Boolean = isAndroid || isIos,
) {
    operator fun invoke(): Boolean {
        val adFreeUntil = settings.getLong(SharedPrefsConstants.AD_FREE_UNTIL_MILLIS, 0L)
        val isAdFreeNow = currentMilliseconds < adFreeUntil
        val hasPurchasedAdFree = settings.getBoolean(SharedPrefsConstants.AD_FREE_PURCHASED, false)

        return hasAdsSdk && !isAdFreeNow && !hasPurchasedAdFree
    }
}
